import { Button } from "@mui/material";
import Grid from "@mui/material/Grid2";
import dayjs from "dayjs";

/**
 * QuarterButton component for selecting quarter date ranges
 *
 * Renders a button that when clicked sets the start and end dates for a specific quarter
 * in the parent component's state.
 *
 * @param {Object} props - Component props
 * @param {string} props.quarter - Quarter identifier (e.g., "Q1", "Q2")
 * @param {number} props.startMonth - Starting month (0-11, where 0 is January)
 * @param {number} props.endMonth - Ending month (0-11, where 0 is January)
 * @param {string} props.label - Descriptive label for the button (e.g., "Jan 1 ➔ Mar 31")
 * @param {Function} props.setSelectedTaskData - State setter function from parent component
 *
 * @example
 * <QuarterButton
 *   quarter="Q1"
 *   startMonth={0}
 *   endMonth={2}
 *   label="Jan 1 ➔ Mar 31"
 *   setSelectedTaskData={setSelectedTaskData}
 * />
 *
 * @returns {JSX.Element} Button wrapped in a Grid component for quarter selection
 */
const QuarterButton = ({ quarter, startMonth, endMonth, label, setSelectedTaskData }) => (
  <Grid>
    <Button
      variant="outlined"
      color="inherit"
      size="large"
      onClick={() => {
        setSelectedTaskData((prev) => ({
          ...prev,
          startDate: dayjs().set("month", startMonth).set("date", 1),
          endDate: dayjs().set("month", endMonth).set("date", 
            [3, 5, 8, 10].includes(endMonth) ? 30 : 31
          ),
        }));
      }}
    >
      {quarter}
      <br />
      {label}
    </Button>
  </Grid>
);

export default QuarterButton;
